import { YofiScoreZodSchema } from "@redotech/redo-model/return";
import * as z from "zod";

/**
 * Schema for the getCustomerYofiScores RPC endpoint
 */
export const getCustomerYofiScores = {
  name: "getCustomerYofiScores" as const,
  input: z.object({ shopifyCustomerId: z.string() }),
  output: z.record(z.string(), YofiScoreZodSchema).nullable(),
};
